import { Model } from "@ofqual/portal-core/core/types";
import { Attachment } from "./Attachment";

type NullableString = string | null;
type NullableNumber = number | null;
type NullableBoolean = boolean | null;
type NullableDate = Date | null;

export type FoiItem = {
  id: string;
  createdByUpn: string;
  createdByDisplayName: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  caseLeadUpn: string;
  caseLeadDisplayName: string;
  referenceNumber: string;
  caseTitle: string;
  sourceId: number;
  status: number;
  stage: NullableNumber;
  dateReceived: string;
  dateResponseDue: Date;
  ragRatingId: NullableNumber;
  categoryId: NullableNumber;
  nameTitle: NullableString;
  fullName: string;
  firstName: string;
  lastName: string;
  email: NullableString;
  telephone: NullableString;
  line1: NullableString; // to be expanded into either an address type or individual address properties
  line2: NullableString;
  line3: NullableString;
  line4: NullableString;
  postcode: NullableString;
  country: number;
  gqvtq: number;
  category: string;
  customerTypeId: NullableNumber;
  caseTypeId: NullableNumber; // FOI, Non-FOI
  complexityId: NullableNumber;
  reasonForExtension: string;

  qualificationTypeId: {
    id: string;
    foiId: number;
    typeId: number;
  }[];

  seriesAndYear: {
    id: string;
    foiId: number;
    seriesId: number;
    year: number;
  }[];

  informationRequested: string; // should this not be an activity?
  summary: string;
  legalInput: NullableBoolean;
  focusId: NullableNumber;
  theme: number;
  directorateId: NullableNumber;
  automatedItSearchRequested: NullableBoolean;
  typeOfResponseId: NullableNumber;
  internalReviewOutcomeId: NullableNumber;
  icoDecisionNoticeId: NullableNumber;
  firstTierTribunalOutcomeId: NullableNumber;
  firstTierTribunalOutcomeDate: NullableDate;
  upperTierTribunalOutcomeId: NullableNumber;
  upperTierTribunalOutcomeDate: NullableDate;
  courtOfAppealOutcomeId: NullableNumber;
  courtOfAppealOutcomeDate: NullableDate;
  exemptionsApplied: number[];
  closedByUpn: string;
  createdDate: string;
  modifiedDate: string;
  foiFiles: File[];
  unpausedTime: number;
  pausedTime: number;
  internalReviewTime: number;
  icoTime: number;
  supportingDocuments?: Attachment[];
};

export const fromApiModel = (model: Model): FoiItem => {
  return {
    ...model,
  } as FoiItem;
};

export enum FoiStatus {
  Open = 0,
  Active = 1,
  Closed = 2,
  Cancelled = 3,
}

export enum FoiStage {
  "Stage 1" = 4,
  "Stage 2" = 5,
  "Stage 3" = 6,
  "Clarification Sought" = 7,
  "Internal Review" = 8,
  "Preliminary ICO" = 9,
  "ICO" = 10,
  "First Tier Tribunal" = 11,
  "Upper Tier Tribunal" = 12,
  "Appeal" = 13,
}

export const toApiModel = (item: FoiItem): Model => {
  // item.seriesAndYear = item.seriesAndYear?.filter(
  //   (foiSeries) => foiSeries.seriesId !== null && foiSeries.year !== null
  // );

  return {
    ...item,
  } as Model;
};
